<div [id]="nodeId" class="chart doughnut">&nbsp;</div>